// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';

(function (window, document, $) {
    $(document).ready(function () {

        // configure Swiper to use modules
        Swiper.use([Navigation, Pagination]);

        // Swiper slider =================================================================================================

        function getCardSliderSettings() {
            var settings = {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                speed: 300,
                spaceBetween: 15,
                slidesPerView: 1.3,
                freeMode: true,
                freeModeMomentumRatio: 0.7,
                freeModeMomentumVelocityRatio: 0.7,
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    }
                },
    
                navigation: {
                    nextEl: '.card-slider-next',
                    prevEl: '.card-slider-prev',
                },
            };

            if($('.related-content-wrapper .card-slider')) {
                settings.loop = false;
            }

            return settings;
        }

        var cardSwiper = new Swiper ('.card-slider-container', getCardSliderSettings());

        // Init Blueconic card sliders 
        $(document).on('init-bc-card-slider', function () {
            var bcCardSwiper = new Swiper ('.bc-card-slider-container', getCardSliderSettings());
        });

        $(document).on('init-onboarding-slider', function () {
            var onboardingSwiper = new Swiper ('.onboarding-slider-container', getCardSliderSettings());
        });

        // Quote slider ==================================================================================
        var quoteSwiper = new Swiper ('.quote-slider', { 
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 25,
            slidesPerView: 1,

            autoplay: {
                delay: 5000,
            },
        
            // If we need pagination
            pagination: {
                el: '.quote-slider-pagination',
                clickable: true
            },

            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true,
            speed: 350,
            easing: 'swing'
        });

        // trainingen quote slider
        var trainingQuoteSwiper = new Swiper ('.trainingen-quote-slider', { 
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 25,

            autoplay: {
                delay: 5000,
            },
        
            // If we need pagination
            pagination: {
                el: '.trainingen-quote-slider-pagination',
                clickable: true
            },

            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true,
            speed: 350,
            easing: 'swing',
            slidesPerView: 1.3,

            breakpoints: {
                992: {
                    slidesPerView: 1.8,
                },
                576: {
                    slidesPerView: 1.5,
                }
            },

            navigation: {
                nextEl: '.trainingen-quote-slider-next',
                prevEl: '.trainingen-quote-slider-prev',
            },
        });

        
        // campagne quote slider
        var campagneQuoteSwiper = new Swiper ('.campagne-quote-slider', { 
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 25,
            slidesPerView: 1,

            autoplay: {
                delay: 5000,
            },
        
            // If we need pagination
            pagination: {
                el: '.campagne-quote-slider-pagination',
                clickable: true
            },

            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true,
            speed: 350,
            easing: 'swing'
        });

        // slider for styles and teachers
        var styleteachSlider = new Swiper('.styleteach-slider-container', {
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 20,
            slidesPerView: 2.6,
            freeMode: true,
            freeModeMomentumRatio: 0.7,
            freeModeMomentumVelocityRatio: 0.7,
            breakpoints: {
                992: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 3.9,
                    spaceBetween: 30,
                }
            },

            navigation: {
                nextEl: '.styleteach-slider-next',
                prevEl: '.styleteach-slider-prev',
            },
        });

        // square slider
        const squareSlider = new Swiper('.square-slider-container', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            speed: 300,
            spaceBetween: 15,
            slidesPerView: 1.6,
            breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            },

            navigation: {
                nextEl: '.wpg-slider-next',
                prevEl: '.wpg-slider-prev',
            },

            pagination: {
                el: '.wpg-slider-pagination',
                type: 'bullets',
                clickable: true,
              },
        });

        var swiper = new Swiper(".yogatv-filter-wrapper", {
            slidesPerView: 'auto',
            enabled: true,
            spaceBetween: 12,
            breakpoints: {
                768: {
                    enabled: false,
                },
            },
        });


        /*$(document).on('init-spotlight-card-slider', function () {
            var spotligtSlider = new Swiper('.yogatv-spotlight-slider-container', {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                speed: 500,
                spaceBetween: 15,
                slidesPerView: 1.2,
                freeMode: true,
                freeModeMomentumRatio: 0.7,
                freeModeMomentumVelocityRatio: 0.7,
                breakpoints: {
                    992: {
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                },
    
                navigation: {
                    nextEl: '.yogatv-spotlight-slider-next',
                    prevEl: '.yogatv-spotlight-slider-prev',
                },
            });
        });*/

        // Update card sliders, this is needed to reinit sliders after an AJAX call for example
        $(document).on('update-card-slider', function () {
            $.each(cardSwiper, function(key, swiper) {
                if(typeof swiper.update == 'function') {
                    swiper.update();
                }
            });

            $.each(styleteachSlider, function(key, swiper) {
                if(typeof swiper.update == 'function') {
                    swiper.update();
                }
            });
        });
    });

}(window, document, jQuery));